<template>
  <div class="accordion" ref="accordion">
    <ul>
      <slot></slot>
    </ul>
  </div>
</template>
<script>
import { Accordion } from "@eds/vanilla";

export default {
  props: ["reload"],
  data() {
    return {
      accordion: {}
    }
  },
  mounted() {
    this.accordion = new Accordion(this.$refs.accordion);
    this.accordion.init();
  },
  watch: {
    reload: function (newVal, oldVal) {
      if(newVal) {
        setTimeout(this.accordion.init.bind(this.accordion), 1);
      }
    }
  }
};
</script>
